import { Typography } from "@cpj-ai/panel-npm-package";
import { Card, CardBody } from "@heroui/react";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Extend dayjs with the isSameOrBefore plugin
dayjs.extend(isSameOrBefore);

interface DateSliderProps {
  dates: string[];
  selectedDate: string | null;
  onSelectDate: (date: string) => void;
  swiperRef: React.MutableRefObject<any>;
}

const DateSlider: React.FC<DateSliderProps> = ({ dates, selectedDate, onSelectDate, swiperRef }) => {
  return (
    <div className="w-full">
      <Swiper
        slidesPerView="auto"
        wrapperClass="p-2.5"
        spaceBetween={8}
        navigation={false}
        modules={[Navigation]}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {dates.map((date) => (
          <SwiperSlide key={date} style={{ width: "auto" }}>
            <Card
              isPressable
              className={`border min-w-[80px] ${
                selectedDate && dayjs(selectedDate).isSame(dayjs(date), "day")
                  ? "border-primary bg-primary-50"
                  : "border-default-200 hover:border-primary hover:bg-primary-50"
              }`}
              onPress={() => onSelectDate(date)}
            >
              <CardBody className="p-3 flex flex-col items-center">
                <Typography
                  className={`text-sm font-medium ${
                    selectedDate && dayjs(selectedDate).isSame(dayjs(date), "day") ? "text-primary" : ""
                  }`}
                >
                  {dayjs(date).format("MMM - ddd")}
                </Typography>
                <Typography
                  className={`text-lg font-bold ${selectedDate && dayjs(selectedDate).isSame(dayjs(date), "day") ? "text-primary" : ""}`}
                >
                  {dayjs(date).format("D")}
                </Typography>
              </CardBody>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default DateSlider;
